import React from "react";
import "./PlantationOneAboutOne.scss";
import { useNavigate } from "react-router-dom";

const PlantationAbout = () => {
  const navigate = useNavigate();
  const handleAdoptClick = () => {
    navigate("/aboutus");
  };
  return (
    <section className="plantation-about">
      <div className="nature-container">
        <div className="about-grid">
          {/* Image Column */}
          <div className="image-column">
            <div className="image-stack">
              {/* Base Image */}
              <div className="base-image-container">
                <img
                  src="/assets/img/greenify/about1.png"
                  alt="Girl planting tree"
                  className="base-image"
                />
              </div>

              {/* Top Left Decor Image */}
              <div className="decor-image top-left">
                <img
                  src="/assets/img/greenify/about2.jpeg"
                  alt="Plant detail"
                />
              </div>

              {/* Bottom Right Decor Image */}
              <div className="decor-image bottom-right">
                <img
                  src="/assets/img/greenify/about3.jpeg"
                  alt="Plant detail"
                />
              </div>
            </div>
          </div>

          {/* Content Column */}
          <div className="content-column">
            <p className="nature-subheading">
              <span>OUR MISSION</span>
              <div className="nature-subheading__underline nature-subheading__underline--left"></div>
            </p>

            <h2 className="nature-heading">
              Planting Hope for a Greener Tomorrow
            </h2>

            <p className="nature-text">
              Dedicated to reforestation and environmental education, transforming barren lands into thriving ecosystems.

            </p>

            <div className="achievements">
              <div className="achievement-item">
                <div className="achievement-icon">✓</div>
                <div className="achievement-text">
                  <h4>10+ Puropose To Adapt a Tree</h4>
                  <p>Teaching sustainable practices</p>
                  
                </div>
              </div>

              <div className="achievement-item">
                <div className="achievement-icon">✓</div>
                <div className="achievement-text">
                  <h4>100+ Communities Engaged</h4>
                  <p>Empowering local populations</p>
                </div>
              </div>

              <div className="achievement-item">
                <div className="achievement-icon">✓</div>
                <div className="achievement-text">
                  
                  <h4>1000+ Trees Planted</h4>
                  <p>Spreading Green Smiles Across India</p>
                </div>
              </div>
            </div>
            {/*             
            <button className="nature-btn--primary">
              Read More About Our Work
              <span className="arrow-icon">→</span>
            </button> */}
            <button className="nature-btn--primary" onClick={handleAdoptClick}>
            It's My Turn <span>→</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PlantationAbout;
